import React, { useState } from 'react';
import {
    BodyTextMedium,
    ComponentTextSmall,
    ComponentTextXSmall,
    HeadingText30,
    HeadingText40,
} from '@modernhealth/vital-components';
import { mediaQuery } from '@modernhealth/vital-foundation';
import styled from '@emotion/styled';
import { useMediaQuery } from '@react-hook/media-query';
import { Link } from 'react-router-dom';

const Container = styled.div(() => ({
    marginBottom: 20,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: ['baseline', 'first baseline'],
    display: 'flex',
}));

let sectionId = 0;

export interface PageSectionProps {
    header: string;
    description?: string;
    cta?: string;
    to?: string;
    className?: string;
}

export const PageSection: React.FC<PageSectionProps> = ({
    children,
    header,
    description,
    cta,
    to,
    className,
}) => {
    // Simple auto-id implementation for now.
    const [id] = useState(++sectionId);

    const smallScreenDetected = useMediaQuery(mediaQuery.maxWidth('md', true));

    const TextComponent = smallScreenDetected ? HeadingText30 : HeadingText40;
    const SecondaryTextComponent = smallScreenDetected ? ComponentTextXSmall : ComponentTextSmall;

    return (
        <section className={className}>
            <Container>
                <div>
                    <h3 id={`section-header-${id}`}>
                        <TextComponent as="span">{header}</TextComponent>
                    </h3>
                    {description ? (
                        <p id={`section-description-${id}`}>
                            <BodyTextMedium fontColor="gray85" as="span">
                                {description}
                            </BodyTextMedium>
                        </p>
                    ) : null}
                </div>

                {cta && to ? (
                    <Link
                        to={to}
                        aria-describedby={`section-description-${id}`}
                        aria-labelledby={`section-header-${id}`}
                        css={{ whiteSpace: 'nowrap' }}
                    >
                        <SecondaryTextComponent fontColor="blue55" as="span">
                            {cta}
                        </SecondaryTextComponent>
                    </Link>
                ) : null}
            </Container>
            {children}
        </section>
    );
};
